import MediaFile from "./MediaFile";

// The shared route loader expects a component without page props.
const MediaFileRoute = () => <MediaFile />;

export default MediaFileRoute;
